import React, { PureComponent } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Button from '../Button/Button';
import Menu from './Menu';

export default class MenuExample extends PureComponent {

  state = {
    buttonClass: 'core-icon-button primary',
  };

  onChange = e => this.setState(e.target.value);

  onRefresh = () => this.forceUpdate();

  onCreateMenuItems = () => [
    <Button key="1">These items were created</Button>,
    <Button key="2">dynamically through a</Button>,
    <Button key="3">callback when the</Button>,
    <Button key="3">menu button was clicked</Button>,
  ];

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Menu.defaultProps} propTypes={Menu.propTypes} propValues={this.state}/>
        <span className="menu-container">
          <Menu {...this.state} onClick={this.onRefresh} onClose={this.onRefresh}>
            <a href="">This menu contains</a>
            <a href="">only links</a>
          </Menu>
        </span>
        <Menu buttonClass="core-icon-button">
          <Button>This menu contains</Button>
          <Button>only buttons</Button>
        </Menu>
        <Menu buttonClass="core-icon-button tertiary" onCreateMenuItems={this.onCreateMenuItems}/> {/* lazily create menu items only when menu is triggered */}
        <SourceCode querySelector=".menu-example .menu-container .core-menu"/>
      </Example>
    );
  }

}
